import { render, staticRenderFns } from "./CardGenericSvg.vue?vue&type=template&id=9be4b118&scoped=true&"
import script from "./CardGenericSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CardGenericSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be4b118",
  null
  
)

export default component.exports